<div class="ws-flex-container-vertical ws-flex-auto">
    <div class="ws-section">
        <div class="ws-section__header">
            <h4 class="ws-section__header__title">
                <!-- <ag-grid-row-count [gridApi]="gridApi" [gridOptions]="gridOptions"></ag-grid-row-count> -->
            </h4>
            <div class="ws-section__header__actions accruals-adjustments-header-actions">
                @if (hasEditPermission) {
                    <div class="ws-section__header__actions__item">
                        <button type="button"
                                class="ace-btn btn-primary btn-sm"
                                (click)="addRow()"
                                position="bottom"
                                [disabled]="editMode">
                            Add New
                        </button>
                    </div>
                }
            </div>
        </div>
    </div>
    <div>
        <ws-ace-loader [show]="serverAction" [size]="2" [hasOverlay]="true"></ws-ace-loader>
        @if (selectionData) {
            <table class="table table-condensed table-striped">
                <thead>
                    <tr>
                        <th>Acct. Period</th>
                        <th>Collector</th>
                        <th>Description</th>
                        <th style="text-align: right;">Accrual</th>
                        <th style="text-align: center;">Write Journal</th>
                        @for (account of selectionData.glAccounts; track account) {
                            <th style="text-align: right;">
                                <div>{{ account.accrualAccountTypeName }}</div>
                                <div>{{ account.accountNumber }}</div>
                            </th>
                        }
                        @if (hasEditPermission) {
                            <th></th>
                        }
                    </tr>
                </thead>
                <tbody>
                    @for (row of adjustments; track row) {
                        <tr (mouseenter)="row.isHovered = true" (mouseleave)="row.isHovered = false;">
                            <td style="width: 125px;">
                                @if (!row.isEdit || row.isPeriodClosed) {
                                    <span>{{ getAcctPeriodName(row.accountingPeriodId) }}</span>
                                }
                                @if (row.isEdit && !row.isPeriodClosed) {
                                    <select class="form-select form-select-sm" [(ngModel)]="row.accountingPeriodId">
                                        @for (x of selectionData.accountingPeriods; track x) {
                                            <option
                                                [ngValue]="x.accountingPeriodId"
                                                [class.not-actual-no-hover]="!x.isClosed"
                                                [disabled]="x.isClosed">
                                                {{ x.name }}
                                            </option>
                                        }
                                    </select>
                                }
                            </td>
                            <td style="width: 225px;">
                                @if (!row.isEdit) {
                                    <span>{{ getCollectorName(row.collectorId) }}</span>
                                }
                                @if (row.isEdit) {
                                    <select class="form-select form-select-sm" [(ngModel)]="row.collectorId">
                                        @for (x of selectionData.collectors; track x) {
                                            <option [ngValue]="x.collectorId">{{ x.name }}</option>
                                        }
                                    </select>
                                }
                            </td>
                            <td>
                                @if (!row.isEdit) {
                                    <span>{{ row.description }}</span>
                                }
                                @if (row.isEdit) {
                                    <input type="text"
                                           [(ngModel)]="row.description"
                                           class="form-control"
                                           maxlength="100">
                                }
                            </td>
                            <td style="text-align: right; width: 125px;">
                                @if (!row.isEdit) {
                                    <parenthetical-currency [value]="row.accrualAmount"></parenthetical-currency>
                                }
                                @if (row.isEdit) {
                                    <input type="text"
                                           class="form-control text-end"
                                           style="display: inline-block; width: 100px"
                                           [(ngModel)]="row.accrualAmount"
                                           currencyMask
                                           [options]="{ allowNegative: true, precision: 2 }">
                                }
                            </td>
                            <td style="text-align: center; width: 125px;">
                                @if (!row.isEdit || row.isPeriodClosed) {
                                    <span>
                                        @if (row.writeJournal) {
                                            <span>Yes</span>
                                        }
                                        @if (!row.writeJournal) {
                                            <span>No</span>
                                        }
                                    </span>
                                }
                                @if (row.isEdit && !row.isPeriodClosed) {
                                    <select class="form-select form-select-sm"
                                            [(ngModel)]="row.writeJournal"
                                            (change)="writeJournalChanged(row)">
                                        <option [ngValue]="true">Yes</option>
                                        <option [ngValue]="false">No</option>
                                    </select>
                                }
                            </td>
                            @for (account of selectionData.glAccounts; track account) {
                                <td style="text-align: right; width: 125px;">
                                    @if (!(row.isEdit && row.writeJournal)) {
                                        <parenthetical-currency [value]="getImpactAmount(row.journalImpacts, account.glAccountId)"></parenthetical-currency>
                                    }
                                    @if (row.isEdit && row.writeJournal) {
                                        <input type="text"
                                               class="form-control text-end"
                                               style="display: inline-block; width: 100px"
                                               [ngModel]="getImpactAmount(row.journalImpacts, account.glAccountId)"
                                               (ngModelChange)="setImpactAmount(row.journalImpacts, account.glAccountId, $event)"
                                               currencyMask
                                               [options]="{ allowNegative: true, precision: 2 }">
                                    }
                                </td>
                            }
                            @if (hasEditPermission) {
                                <td style="width: 1px;">
                                    @if (row.isEdit) {
                                        <div style="white-space: nowrap;">
                                            <button class="ace-btn has-icon btn-sm btn-primary"
                                                    style="margin: 0;"
                                                    (click)="save(row)">
                                                <i class="fa fa-save"></i>
                                            </button>
                                            <button class="ace-btn has-icon btn-sm btn-primary btn-danger"
                                                    style="margin: 0;"
                                                    (click)="cancel(row)">
                                                <i class="fa fa-close"></i>
                                            </button>
                                        </div>
                                    }
                                    @if (!row.isEdit && !editMode && !(row.isPeriodClosed && row.writeJournal)) {
                                        <div style="white-space: nowrap;"
                                             [class.invisible]="!row.isHovered">
                                            <button class="ace-btn btn-sm" style="margin: 0;" (click)="edit(row)">
                                                <i class="fa fa-pencil"></i>
                                            </button>
                                            <button class="ace-btn btn-sm btn-primary btn-danger"
                                                    style="margin: 0;"
                                                    (click)="delete(row)">
                                                <i class="fa fa-trash"></i>
                                            </button>
                                        </div>
                                    }
                                </td>
                            }
                        </tr>
                    }
                </tbody>
            </table>
        }
    </div>
</div>
